export const SpamQuestionActors = {
    SPAM_QUESTION_LIST:'SPAM_QUESTION_LIST',
    SPAM_QUESTION_TOGGLE:'SPAM_QUESTION_TOGGLE'
}